<div class="split-form">
  <div class="image-side font-weight-bolder">
    <h1 class="font-weight-bolder">Welcome Back!</h1>
    <h6 class="font-weight-light">Enter your details to access your account</h6>
  </div>
  <div class="form-side">
    <div class="form">
      <h2 class="text-center font-weight-bolder">Sign In</h2>
      <form [formGroup]="loginForm" (submit)="onSubmit()">
        <input type="text" placeholder="Phone Number" formControlName="username" maxlength="10" (keypress)="allowOnlyNumbers($event)">
        <span class="text-danger" *ngIf="loginErrors.username">{{ this.loginErrors.username }}</span>
        <div class="password-container">
          <input
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Password"
            formControlName="password"
            
          >
          <i class="bi" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"
             (click)="togglePasswordVisibility()"></i>
        </div>
        <span class="text-danger" *ngIf="loginErrors.password">{{ this.loginErrors.password }}</span>
        <button type="submit">Login</button>

       <!-- <p class="mt-3 mb-0 text-bold text-center">New to Lovely Fashion? <a [routerLink]="['/register']"
                                                                             class="text-decoration-none">Sign up</a>
        </p>-->
      </form>
    </div>
  </div>
</div>
